import styled, { css } from 'styled-components';

export const Container = styled.div`
  border-top: 2px solid var(--light-blue);
  border-bottom: 2px solid var(--light-blue);
  padding: .15rem;
  width: 10rem;
  display: flex;
  align-items: center;
  justify-content: space-between;
  position: relative;
  cursor: pointer;

  @media (max-width: 720px) { 
    width: 100px;
    margin:0 .5rem;
  }

  ${props => props.isErroded && css`
    border-color: #ff073a;
    color: #ff073a;
  `}
  ${props => props.isFocused && css`
    color: var(--light-blue);
    border-color: var(--light-blue);

  `}
  ${props => props.isFilled && css`
    color: var(--light-blue);
  `}

  button {
    border: 0;
    background: 0;
    z-index: 0;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;

    label {
      cursor: pointer;
      font-weight: normal;
      font-size: 1.1rem;
      color: var(--gray-800);
    }
  }

`;

export const Checkbox = styled.div`
  margin-bottom: .5rem;
  width: 100%;
  padding: .45rem;
  animation: fade 1s;
  transition: background .2s;

  &:hover {
    background: var(--light-gray);
  }

  &:last-child {
    margin-bottom: 0;
  }
 
  button {
    background: none;
    outline: 0;
    display: flex;
    align-items: center;
    justify-content: space-between;
    
    div {
      border: 2px solid var(--light-green);
      border-radius: 4px;
      height: 20px;
      width: 20px;
    }

    span {
      margin-right: 10px;
      color: var(--gray-800);
      font-weight: normal;
      font-size: 1rem;
    }
  }

  ${props => props.isActive && css`
    button {
      div {
        display: flex;
        align-items: center;
        background: var(--light-green);
      }
    }
  `}
`;

export const Popover = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  position: absolute;
  top: 1.6rem;
  right: 0;
  margin-top: 10px;
  width: 10rem;
  border-radius: 0.25rem;
  
  transition:  0.4s;
  
  ${props => props.isFocused ? css`
    height: 120px;
    box-shadow: 0px 2px 5px #0000008c;
    background: #FFF;
  ` : 
  css`
    height: 0;
  `};

  ${props => (props.isFocused && props.diferrentheight === "status") && css`
    height: 160px;  
  `}
`;
